import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { BULK_INVOICE_ACTION, BULK_INVOICE_TYPE } from "constants/invoicing";
import { useToast } from "hooks/useToast";
import { useBulkUpdateInvoiceMutation } from "store/apis/invoices";
import { BackendError } from "types/utils/error";
import { pluralize } from "utils/pluralize";

export default function InvoiceUnlinkCreditNotesModal({
  groupId,
  entityId,
  selectedRows,
  success,
}: {
  groupId: string;
  entityId: string;
  selectedRows: string[];
  success: () => void;
}) {
  const [bulkUpdateOrDeleteInvoice, { isLoading: isUnlinkingCreditNotes }] =
    useBulkUpdateInvoiceMutation();
  const { alertToast, successToast } = useToast();

  const handleUnlinkCreditNotes = async () => {
    try {
      await bulkUpdateOrDeleteInvoice({
        groupId,
        entityId,
        record_ids: selectedRows,
        action: BULK_INVOICE_ACTION.UNLINK_CREDIT_NOTES,
        type: BULK_INVOICE_TYPE.INVOICE,
      }).unwrap();
      success();
      successToast({ message: "Credit notes unlinked successfully" });
    } catch (error) {
      alertToast({
        message:
          (error as BackendError).data?.error?.message ??
          "Failed to unlink credit notes",
      });
    }
  };

  return (
    <>
      <StatusModal type="warning" title="Unlink credit notes?">
        Are you sure you want to unlink all credit notes linked to the{" "}
        <b>
          {pluralize(
            selectedRows.length,
            "selected invoice",
            "selected invoices"
          )}
        </b>
        ? This will update the due balance for these invoices.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button size="small">Cancel</Button>
        </Modal.RawClose>
        <Button
          customType="primary"
          size="small"
          onClick={handleUnlinkCreditNotes}
          isLoading={isUnlinkingCreditNotes}
          disabled={isUnlinkingCreditNotes}
        >
          Confirm
        </Button>
      </Modal.FooterButtonGroup>
    </>
  );
}
